import React from 'react'
import { theme } from '../../../theme/theme'
import { IDropdownSelectOption } from '../../common/DropdownSelect/IDropdownSelectOption'
import { Icon, IconChoices } from '../../common/Icon'
import { NotificationBadge } from '../../notifications/NotificationBadge/NotificationBadge'

interface DropdownItemContentProps {
  option: IDropdownSelectOption
  height?: string | number
  wrapText?: boolean
}

export const DropdownItemContent = ({
  option,
  height = 'h-8',
  wrapText = false,
}: DropdownItemContentProps): JSX.Element => {
  const textClassName = wrapText
    ? 'min-w-0 flex-1 whitespace-normal break-words'
    : 'flex truncate'

  return (
    <div
      style={{ ...theme.textVariants.base }}
      className={`flex items-center gap-2 overflow-hidden ${
        wrapText ? '' : height ?? ''
      }`}
    >
      {option.image || (option.icon && <Icon icon={option.icon} />)}
      <span className={textClassName}>{option.customText || option.label}</span>
      {option.showCheckmark && (
        <Icon icon={IconChoices.CHECKMARK} highlighted />
      )}
      {option.displayNotificationBadge && (
        <NotificationBadge
          className="ml-2 mt-[2px]"
          show
          absoluteOffset={false}
        />
      )}
    </div>
  )
}
